<template>
    <div id="contact-page">
        <!--================ About History Area  =================-->
        <section class="about_history_area section_gap">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 d_flex align-items-center">
                        <div class="about_content " style="width:100%">
                            <h2 class="title title_color">Q & A <br></h2>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <img class="img-fluid" src="../assets/news/bed-bedroom-bedsheet-2387753.jpg" alt="img">
                    </div>
                </div>
                <div class="row about_travel_intro">
                    <div class="col-md-12 d_flex align-items-center">
                        <div class="about_content ">
                            <h2 class="title title_color"></h2>
                            <p><small> + 更多入住旅遊交通等相關疑問，先來這邊找答案</small></p>
                        </div>
                    </div>
                </div>

                <div class="contact-way">
                    <div class="contact-way-area row justify-content-around">
                        <div class="way-by-public contact-way-type col-md-10">
                            <div class="way-name">結帳相關</div>
                            <div class="short-border"></div>
                            <div class="way-detail">
                                <div>是否可以刷卡?</div>
                                民宿現場有提供現金及信用卡兩種付款方式。<br/>
                                如果您不是由官網預訂，需要預付訂金，這部分僅提供匯款方式支付訂金金額，餘款可於民宿辦理入住時，使用現金或信用卡繳清。<br/>
                                如果您是在線上OTA訂房網站上預訂且為現場付款，則可以在辦理入住時，使用現金或信用卡支付。
                            </div>
                            <div class="way-detail">
                                <div>有配合國旅卡嗎?</div>
                                富杉晴民宿是國旅卡的特約住宿業，歡迎使用國旅卡。
                            </div>
                        </div>
                        <div class="way-by-public contact-way-type col-md-10">
                            <div class="way-name">交通相關</div>
                            <div class="short-border"></div>
                            <div class="way-detail">
                                <div>有提供火車站/機場接駁服務嗎?</div>
                                富杉晴民宿目前尚無提供接駁服務哦!<br/>
                    台東的公共運輸相對來說不密集，旅遊景點也分市區/海線/山線，我們會建議您開車/租車會較為便利。<br/>
                    若想了解公車抵達方式，可至<a href="https://rich-sunshine.tw/contact">交通方式</a>查看。<br/>
                    若有租車需求，我們有配合的租車公司可以提供給有需要的旅人哦!
                            </div>
                            <div class="way-detail">
                                <div>坐火車該在哪一站下車?</div>
                                搭乘火車的旅人，請由台東站下車哦! <br/>
                                由台東火車站到富杉晴民宿車程約20分鐘。
                            </div>
                        </div>
                        <div class="way-by-public contact-way-type col-md-10">
                            <div class="way-name">旅遊活動相關</div>
                            <div class="short-border"></div>
                            <div class="way-detail">
                                <div>民宿可以烤肉嗎?</div>
                                富杉晴民宿可以戶外烤肉哦，需提早預訂且房客限定。<br/><br/>
                                烤肉方案價格: 請到 <a href="https://rich-sunshine.tw/news/BBQ">Let's BBQ 烤肉方案</a>了解<br/>
                                由官方LINE進行詢問與預約哦!
                            </div>
                            <div class="way-detail">
                                <div>民宿離海邊距離近嗎?</div>
                                若要到海邊玩水或看潮間帶的旅人，距離民宿最近的地點是[富山護漁區]和[杉原灣]。<br/>
                                富山護漁區：由富杉晴民宿步行大約10-15分鐘，開車大約2-3分鐘。
                                杉原灣：由富杉晴民宿開車大約3-4分鐘
                            </div>
                            <div class="way-detail">
                                <div>民宿有泳池嗎/民宿有小朋友戲水池嗎?</div>
                                民宿沒有游泳池的喲！如果看到照片藍色磁磚的那是景觀池，是不能下去玩的拉！<br/>
                                
                            </div>
                        </div>
                        <div class="way-by-private contact-way-type col-md-10">
                            <div class="way-name">住宿相關</div>
                            <div class="short-border"></div>
                            <div class="way-detail">
                                <div>A棟和B棟差在哪裡?</div>
                                民宿兩棟建築都是同時開工完工並開賣的喲。<br/>
                                A棟一樓前台為大廳與交誼廳所在，一到三樓兩面分別為面山與面海房型，裝潢以家庭溫馨風作為主要風格，入內A棟需脱鞋。<br/>
                                B棟一樓一半為早餐用餐區，一到三樓為精緻面山或花園房型，由戶外面海走廊開門進入房內，以獨立輕工業風作為房間設計靈感。<br/>
                                不論哪一棟，房內設施與備品皆相同，大部分房型皆有陽台與浴缸（除簡約雙人房無浴缸無陽台/ 山景湯屋雙人房無陽台），各房型細節說明可至房型查看。<br/>
                                兩棟四樓皆有景觀訂樓可上樓觀星或日出。<br/>
                                不論您是入住哪一棟，都可以至A棟交誼廳、頂樓及B棟餐廳(只有早餐用餐開放)、頂樓。
                            </div>
                            <div class="way-detail">
                                <div>櫃台/管家是24小時的嗎?</div>
                                櫃台/管家服務時間為8:00am – 10:00pm，為確保您入住後房務方面之服務，敬請於10:00前跟我們反應以便及時提供服務與協助。
                                請見<a href="https://rich-sunshine.tw/know">入住退房時間</a>之說明
                            </div>
                            <div class="way-detail">
                                <div>若有五位大人，可以加床入住四人房嗎?</div>
                                四人房最多入住四位大人(超過11歲即視為佔床入住)，如需五位入住四人房，可以考慮可提供*加床之四人房型或是可以選擇六人房型。<br/><br/>
                                *加床：部分房型才有提供加床服務，並且每房最多加床一位。<br/>
                                請見<a href="https://rich-sunshine.tw/know">加床加人規定</a>之說明
                                
                            </div>
                            <div class="way-detail">
                                <div>如果小孩一起入住需要加床/加人費嗎?</div>
                                請見<a href="https://rich-sunshine.tw/know">加床加人規定</a>之說明
                                
                            </div>
                            <div class="way-detail">
                                <div>有提供嬰兒床/嬰兒設備嗎?</div>
                                富杉晴民宿可在客房內提供嬰兒床、澡盆、洗澡矮凳，可供一歲以下您的寶貝使用。<br/>
                                以上嬰幼兒設備皆為預約制，數量有限，若有需要請先提前預訂<br/>
                                嬰兒床為收費制，將會另外酌收清潔費用 NTD300/次<br/><br/>
                                
                                民宿另於交誼大廳有提供消毒鍋開放使用<br/>
                                尚無提供床圍、嬰幼兒沐浴品組等設備用品，有需求的旅客們可以自行準備唷！
                                <br/>
                                
                            </div>
                            <!--
                            <div class="way-detail">
                                <div>可以包棟嗎?</div>
                                富杉晴民宿有兩棟建築，可分開提供包棟與包棟優惠價。<br/>
                                A棟: 可容納 42人; 雙人房4間/ 四人房7間/ 六人房1間<br/>
                                B棟: 可容納 38人; 雙人房3間/ 四人房5間/ 六人房2間<br/>
                                有興趣的旅人們可至<a href="https://rich-sunshine.tw/news/SOLE">獨樂樂不如眾樂樂 x 包棟享受</a>了解<br/>
                                如果有包棟的需求或了解包棟價位，請直接使用FB或官方LINE與我們聯絡詢問訂房唷!<br/>
                                若該棟已有房型被預訂，恕無法提供包棟服務，請及早預訂。
                                
                            </div>
                            -->
                            <div class="way-detail">
                                <div>寵物可以入住嗎/可以攜帶寵物嗎?</div>
                                我們也是很愛動物的寵物控，但因需考量會有其他旅人對寵物過敏，<br/>
                                僅開放特定樓層之指定房間可供帶寵物同遊的旅人們入住哦!<br/><br/>
                                開放寵物入住房間(皆為不提供加床房型):<br/>
                                *寵物精緻雙人房: B101 <br/>
                                *寵物精緻四人房: B102 & B103<br/>
                                
                                
                            </div>
                            <div class="way-detail">
                                <div>有電梯嗎?</div>
                                富杉晴民宿為三樓建築，內皆為樓梯，並無電梯哦!<br/><br/>
                                若行李繁重的旅人，我們也會熱情地協助您將行李搬到房間內。<br/>
                                若有不便於爬至高樓層的旅人，也可以在預訂時告訴我們，可以為您推薦及安排1F或2F的房間!
                                
                            </div>
                            <div class="way-detail">
                                <div>餐廳可以使用的嗎/廚房是開放使用的嗎/可以使用廚房煮東西嗎?</div>
                                民宿餐廳只作為早餐用餐時段提供給旅客們享用早餐。<br/>
                                無提供也不開放廚房或餐廳，所以在民宿是沒有餐廳可以聚會用餐，也沒有廚房可以開火或烹煮的哦! <br/>
                                
                            </div>
                            <div class="way-detail">
                                <div>請問住宿有附早餐/晚餐嗎?</div>
                                
                                
                                早餐供應請見<a href="https://rich-sunshine.tw/know">餐點提供時間</a>之說明                              
                                <br/>
                                午晚餐或其他餐點，尚無提供。<br/>
                                台東有很多好吃的小吃，建議旅人們可以多嚐嚐台東美食哦。
                            </div>
                            <div class="way-detail">
                                <div>可以加購早餐嗎?</div>
                                可以額外加購早餐哦，加購價為$250。<br/>
                                早餐為套餐式，不分大人/小孩。<br/>
                                最遲請於入住當日18:00前提前告知，若有特殊需求或素食者，請於check in時告訴我們，以便我們為您準備素食餐點。<br/>
                                早餐供應請見<a href="https://rich-sunshine.tw/know">餐點提供時間</a>之說明  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--================ About History Area  =================-->
    </div>
</template>

<script>

export default {
  name: 'requlation',
  components: {}
}
</script>
<style lang="scss">
$contact-info-color: #2f2f2f;
.hint-color {
    color: brown;
}
.about_contact_info {
    max-width: 300px;
    margin: auto;
    text-align: left;
}
.about_travel_intro {
    text-align: left;
    border-top: 2px solid;
    margin-top: 20px;
}
#contact-page {
    .contact-way {
        padding: 5rem 16px;
        background: rgba(0, 0, 0, 0.1);
        position: relative;
        // &:before {
        //     content: '';
        //     position: absolute;
        //     top: 0;
        //     /* border-bottom: 25px rgba(0, 0, 0, 0.1) solid; */
        //     border-right: 25px rgba(0, 0, 0, 0.1);
        //     border-left: 25px rgba(0, 0, 0, 0.1) solid;
        //     border-top: 25px solid white;
        //     left: 50%;
        //     margin-left: -25px;
        // }
        .title {
            font-size: 32px;
            font-weight: 100;
            color: #000;
            // margin-bottom: 5rem;
        }
        .contact-way-area .contact-way-type {
            .way-name {
                color: #FF6161;
                font-size: 18px;
                text-align: center;
                transition: 1s ease;
            }
            .way-detail {
                margin-top: 10px;
                & > div {
                    font-weight: 600;
                        font-size: larger;
                    margin-top: 50px;

                }
            }
            .short-border {
                width: 4rem;
                height: 1px;
                background: #FF6161;
                margin: .5rem auto 2rem auto;
            }
            // padding: 5rem 4.5rem;
            // background: rgba(4, 81, 132, 1);
            // color: white;
            // font-weight: 100;
            letter-spacing: 1px;
            text-align: left;
            transition: 1s ease;
            margin-bottom: 60px;
            // &:hover {
            //     background: #000;
            //     .way-name {
            //         font-size: 32px;
            //     }
            // }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/QA.vue